import React from 'react'
import Calender from '../../Layout/Calender'

const CalenderPage = () => {
  return <Calender />
}

export default CalenderPage
